import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getGeneralDonationData, type GeneralDonationData } from '../config/firebase';
import { useCurrency } from '../hooks/useCurrency';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft } from 'lucide-react';

export function DonationPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const currency = useCurrency();
  const { user } = useAuth();
  const [donation, setDonation] = useState<GeneralDonationData | null>(null);

  useEffect(() => {
    const fetchDonation = async () => {
      if (id) {
        const data = await getGeneralDonationData();
        setDonation(data);
      }
    };
    fetchDonation();
  }, [id]);

  const handleParticipate = () => {
    if (!user) {
      localStorage.setItem('redirectAfterAuth', `/donation/${id}`);
      navigate('/login');
    } else {
      navigate(`/donation/${id}`);
    }
  };

  if (!donation) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-gray-400">Chargement...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <div className="bg-black/50 text-white p-4 flex items-center justify-between sticky top-0 z-10 backdrop-blur-lg border-b border-white/10">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-lg font-bold">Aperçu de la donation</h1>
        <div className="w-6" />
      </div>

      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <div className="bg-white/5 backdrop-blur-lg rounded-3xl p-6 border border-white/10">
          <div className="flex items-center gap-4 mb-6">
            <img 
              src={donation.imageUrl} 
              alt={donation.donorName}
              className="w-20 h-20 rounded-xl object-cover"
            />
            <div>
              <h2 className="text-xl font-bold text-white">{donation.title}</h2>
              <p className="text-gray-400">{donation.donorName}</p>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-sm text-gray-400">Montant</p>
            <p className="text-3xl font-bold text-white">
              {donation.amount.toLocaleString()} {currency}
            </p>
          </div>

          <div className="space-y-4 mb-8">
            <p className="text-gray-300">{donation.description}</p>
            {donation.details && (
              <p className="text-gray-400 text-sm">{donation.details}</p>
            )}
          </div>

          <button
            onClick={handleParticipate}
            className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-4 rounded-xl transition-colors"
          >
            {user ? 'Participer maintenant' : 'Se connecter pour participer'}
          </button>

          {!user && (
            <p className="text-center text-gray-400 mt-4 text-sm">
              Pas encore inscrit ? {' '}
              <button 
                onClick={() => navigate('/register')}
                className="text-green-400 hover:text-green-300 transition-colors"
              >
                Créer un compte
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
} 